import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { LoadAllAbout, UpdateAbout, UpdateAccueil } from '../../../../actions/ActivitesPages/ManagerPageAction';
import { baseUrl } from '../../../../nametitle/dataUrl';
import { Localvalue } from '../../../../nametitle/localValue';
import { getDataFromFile } from '../../../../actions/SearchAction';

const FormAbout = () => {
    //. Activité 1
    const [reading, setreading] = useState(true);
    const [id, setid] = useState();

    const [coverPictureAbout1, setcoverPictureAbout1] = useState();
    const [videoAbout, setVideoAbout] = useState();
    const [titleAbout, settitleAbout] = useState();
    const [content, setcontent] = useState();
    const [strategy, setstrategy] = useState();
    const [description1, setdescription1] = useState();

    // Accitite 2
    const [coverPictureAbout2, setcoverPictureAbout2] = useState();
    const [titleAbout2, settitleAbout2] = useState();
    const [description2, setdescription2] = useState();




    const [Loading, setLoading] = useState();

    useEffect(() => {
        const object = getDataFromFile(Localvalue.activitePageData);
        setVideoAbout(object && object.about && object.about.activite1 && object.about.activite1.video ? object.about.activite1.video : "");
        setcoverPictureAbout1(object && object.about && object.about.activite1 && object.about.activite1.coverPicture ? object.about.activite1.coverPicture : "");
        settitleAbout(object && object.about && object.about.activite1 && object.about.activite1.title ? object.about.activite1.title : "");
        setcontent(object && object.about && object.about.activite1 && object.about.activite1.content ? object.about.activite1.content : "");
        setdescription1(object && object.about && object.about.activite1 && object.about.activite1.description ? object.about.activite1.description : "");
        setstrategy(object && object.about && object.about.activite1 && object.about.activite1.strategy ? object.about.activite1.strategy : "");
        // ***************************************************     Activté 2
        setcoverPictureAbout2(object && object.about && object.about.activite2 && object.about.activite2.coverPicture ? object.about.activite2.coverPicture : "");
        settitleAbout2(object && object.about && object.about.activite2 && object.about.activite2.title ? object.about.activite2.title : "");
        setdescription2(object && object.about && object.about.activite2 && object.about.activite2.description ? object.about.activite2.description : "");
        
        LoadAllAbout(
            setid, setVideoAbout, setcoverPictureAbout1, settitleAbout, setdescription1, setstrategy,
            setcontent, setcoverPictureAbout2, settitleAbout2, setdescription2
        );
    }, []);
    function ReadChamp() {
        setreading(!reading)
    }

    // Upload des fichier 
    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader(); fileReader.readAsDataURL(file); fileReader.onload = () => { resolve(fileReader.result); };
            fileReader.onerror = (error) => { reject(error); };
        });
    };

    // Video 
    function uploadSingleVideo(base64) {
        setLoading(true);
        axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
            .then((res) => { setVideoAbout(res.data); alert("vidéo uploaded Succesfully"); })
            .then(() => setLoading(false))
            .catch(console.log);
    }
    const uploadVideo = async (event) => {
        const files = event.target.files;
        console.log(files.length);
        if (files.length === 1) {
            const base64 = await convertBase64(files[0]);
            uploadSingleVideo(base64); return;
        }
        const base64s = [];
        for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
    };




    // Image 1
    function uploadSingleImage1(base64) {
        setLoading(true);
        axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
            .then((res) => { setcoverPictureAbout1(res.data); alert("image uploaded Succesfully"); })
            .then(() => setLoading(false))
            .catch(console.log);
    }
    const uploadImage1 = async (event) => {
        const files = event.target.files;
        console.log(files.length);
        if (files.length === 1) {
            const base64 = await convertBase64(files[0]);
            uploadSingleImage1(base64); return;
        }
        const base64s = [];
        for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
    };



    // Image 2
    function uploadSingleImage2(base64) {
        setLoading(true);
        axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
            .then((res) => { setcoverPictureAbout2(res.data); alert("image uploaded Succesfully"); })
            .then(() => setLoading(false))
            .catch(console.log);
    }
    const uploadImage2 = async (event) => {
        const files = event.target.files;
        console.log(files.length);
        if (files.length === 1) {
            const base64 = await convertBase64(files[0]);
            uploadSingleImage2(base64); return;
        }
        const base64s = [];
        for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
    };





    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();

                UpdateAbout(id, videoAbout, coverPictureAbout1, titleAbout, content, coverPictureAbout2, titleAbout2, description2
                )
            }}
        >
            <h2 className="translatable text-2xl py-2 bg-light">Page a propos de nous ? </h2>


            <div className="translatable input-group mb-3 flex flex-row space-x-5">
                <input onChange={ReadChamp} type="checkbox" className="translatable h-[30px] w-[30px]" />
                <label>rendre les champ disponible </label>
            </div>
            <div className="translatable bg-info my-3">
                <h2>activté 1</h2>
            </div>

            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">Vidéo</span>
                    <input onChange={uploadVideo} readOnly={reading} type="file" className="translatable form-control" accept=".MP4" placeholder="" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable border-green-400 p-3">
                {coverPictureAbout1 && (<img src={`${coverPictureAbout1}`} className="translatable h-[100px] w-[100px]" />)}
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">Image 1</span>
                    <input onChange={uploadImage1} readOnly={reading} type="file" className="translatable form-control" accept=".JPG , PNG, JPEG" placeholder="" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">titre de l{"'"}image</span>
                    <input readOnly={reading} value={titleAbout} onChange={(e) => { settitleAbout(e.target.value) }} type="text" className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable border-green-400 p-3">

                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">content</span>
                    <textarea readOnly={reading} value={content} onChange={(e) => { setcontent(e.target.value) }} className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>




            <div className="translatable bg-info my-3">
                <h2>activté 2</h2>
            </div>


            <div className="translatable border-green-400 p-3">
                {coverPictureAbout2 && (<img src={`${coverPictureAbout2}`} className="translatable h-[100px] w-[100px]" />)}
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">Image de fond</span>
                    <input onChange={uploadImage2} readOnly={reading} type="file" className="translatable form-control" accept=".JPG , PNG, JPEG" placeholder="" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">titre de l{"'"}image</span>
                    <input readOnly={reading} value={titleAbout2} onChange={(e) => { settitleAbout2(e.target.value) }} type="text" className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>


            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">description 2</span>
                    <textarea readOnly={reading} value={description2} onChange={(e) => { setdescription2(e.target.value) }} className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable  mb-3 mt-5">
                <button type="submit" className="translatable btn bg-gray-900 btn-dark py-3 px-2">Enregistrer changement </button>
            </div>

        </form>
    )
}

export default FormAbout;